<template>
  <div class="enrolling-statistics-enroll-num">
    <StatisticsCommon :title="name" :export-data="exportData">
      <div class="main-container">
        <div class="query-container">
          <div class="tips">
            新生报名人数：<span>{{totalNum}}</span>人
          </div>
          <CheckAllSelect v-model="siteIds" filterable multiple labelKey="name" valueKey="id" :optionList="siteList" collapse-tags>
          </CheckAllSelect>
          <el-radio-group v-model="dateType" @input="changeDateType">
            <el-radio-button label="day">按天</el-radio-button>
            <el-radio-button label="week">按周</el-radio-button>
            <el-radio-button label="month">按月</el-radio-button>
            <el-radio-button label="year">按年</el-radio-button>
          </el-radio-group>
          <el-date-picker
            v-if="dateType === 'day' || dateType === 'week'"
            v-model="date"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="dayPickerOptions">
          </el-date-picker>
          <el-date-picker
            v-if="dateType === 'month'"
            v-model="date"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            value-format="yyyy-MM"
            :picker-options="monthPickerOptions"
          ></el-date-picker>
        </div>
        <div class="graph-wrap">
          <EChartContainer ref="chart"></EChartContainer>
        </div>
      </div>
    </StatisticsCommon>
  </div>
</template>

<script>
import moment from 'moment'
import StatisticsCommon from '../../common/card'
import CheckAllSelect from '../../common/checkAllSelect'
import EChartContainer from '../../../../../../../elements/EChartContainer'
export default {
  name: 'EnrollingStatisticsEnrollNum',
  components: {
    StatisticsCommon,
    EChartContainer,
    CheckAllSelect
  },
  props: {
    name: String,
    type: String,
    siteList: Array,
    batchId: {
      required: false,
      type: String
    }
  },
  data () {
    return {
      siteIds: [],
      date: [],
      totalNum: '--',
      dateType: 'day',
      dayPickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      monthPickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick (picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick (picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      chartOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {type: 'plain'},
        dataset: {
          source: []
        },
        xAxis: {
          type: 'category',
          axisPointer: {
            type: 'shadow'
          },
          axisLabel: {
            interval: 0
          }
        },
        dataZoom: [
          {
            type: 'slider',
            xAxisIndex: 0,
            filterMode: 'none'
          },
          {
            type: 'inside',
            xAxisIndex: 0,
            filterMode: 'none'
          }
        ],
        yAxis: {},
        series: []
      }
    }
  },
  methods: {
    changeDateType () {
      this.date = []
    },
    loadData () {
      if (this.dateType === 'day' || this.dateType === 'week' || this.dateType === 'month') {
        if (!this.date || this.date.length !== 2) {
          return
        }
      }
      if (this.batchId && this.dateType && this.siteIds && this.siteIds.length) {
        this.$ajax({
          url: '/workspace/manager/enrolling/statistics/queryEnrollStudentNumData',
          method: 'post',
          data: this.$qs.stringify({
            batchId: this.batchId,
            siteIds: this.siteIds,
            dateType: this.dateType,
            startDate: this.date.length ? this.date[0] : '',
            endDate: this.date.length ? this.date[1] : ''
          }, {arrayFormat: 'repeat'})
        }).then((response) => {
          if (response['data']) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.chartOption.dataset.source = response.data['data'] || []
                let series = []
                for (let i = 0; i < this.chartOption.dataset.source.length - 1; i++) {
                  series.push({type: 'bar', seriesLayoutBy: 'row', label: {show: true, position: 'top'}})
                }
                this.chartOption.series = series
                this.totalNum = response.data['totalNum']
                this.initChart()
                break
              }
            }
          }
        })
      }
    },
    initChart () {
      const chart = this.$refs.chart
      if (chart) {
        chart.clear()
        chart.setOption(this.chartOption)
      }
    },
    exportData () {
      if (this.dateType === 'day' || this.dateType === 'week' || this.dateType === 'month') {
        if (!this.date || this.date.length !== 2) {
          return
        }
      }
      if (this.batchId && this.dateType && this.siteIds && this.siteIds.length) {
        this.$ajax({
          url: '/workspace/manager/enrolling/statistics/exportEnrollStudentNumData',
          method: 'post',
          data: this.$qs.stringify({
            batchId: this.batchId,
            siteIds: this.siteIds,
            dateType: this.dateType,
            startDate: this.date.length ? this.date[0] : '',
            endDate: this.date.length ? this.date[1] : ''
          }, {arrayFormat: 'repeat'})
        }).then((response) => {
          if (response['data']) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                window.location.href = response.data['fileUrl']
                break
              }
              default: {
                this.$message.error('导出失败')
              }
            }
          }
        })
      }
    }
  },
  watch: {
    siteIds: function () {
      this.loadData()
    },
    batchId: function () {
      this.loadData()
    },
    date: function () {
      this.loadData()
    },
    siteList: function (val) {
      if (!this.siteIds || this.siteIds.length === 0) {
        this.siteIds = val.map(site => site.id).slice(0, 1)
        this.date = [moment().weekday(0).format('YYYY-MM-DD'), moment().weekday(6).format('YYYY-MM-DD')]
      }
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style lang="scss">
.enrolling-statistics-enroll-num {
  width: 100%;
  padding: 10px 20px;
  border-bottom: solid 1px #EBEEF5;
  .main-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .query-container {
      display: flex;
      align-items: center;
      gap: 20px;
      padding-bottom: 10px;
      .tips {
        span {
          font-weight: bold;
        }
      }
    }
    .graph-wrap {
      width: 100%;
      height: 500px;
      .e-chart-container {
        height: 100%;
      }
    }
  }
}
</style>
